import React, { Component } from "react";
import { Switch } from "react-router";
import { TrainPublicPage } from "../pages/train-public-page/TrainPublicPage";
import { TrainLayout } from "./TrainLayout";
import { RouteWithLayout } from "./RouteWithLayout";

export class TrainDefaultSwitch extends Component {
  render() {
    return (
      <Switch>
        <RouteWithLayout layout={TrainLayout} exact path="/" component={TrainPublicPage} />
      </Switch>
    );
  }
}
